'use client';

import React from 'react';
import { Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { useEstimator } from '../../context/EstimatorContext';

const SavedQuantitiesGrid = () => {
  const { formData } = useEstimator();
  const savedQuantities = formData?.quantities || [];

  return (
    <Box mt={4}>
      <Typography
        variant="h6"
        mb={2}
        sx={{
          backgroundColor: '#223A64',
          color: 'white',
          padding: '8px 16px',
          borderRadius: 1,
        }}
      >
        Project Metrics
      </Typography>

      <Box
        className="ag-theme-alpine"
        sx={{
          width: '100%',
          height: 500,
        }}
      >
        <AgGridReact
          rowData={savedQuantities}
          columnDefs={[
            { headerName: 'No.', field: 'no', width: 80 },
            { headerName: 'Type', field: 'type', flex: 2 },
            { headerName: 'Quantity', field: 'quantity', width: 120 },
            { headerName: 'Units', field: 'units', width: 100 },
            { headerName: 'Notes', field: 'notes', flex: 2 },
            { headerName: 'By', field: 'by', width: 100 },
            { headerName: 'Source', field: 'dataSource', flex: 1 },
          ]}
          defaultColDef={{
            resizable: true,
            editable: false,
            cellStyle: {
              backgroundColor: '#f9f9f9',
              color: '#555',
              textAlign: 'left',
            },
          }}
          domLayout="normal"
          suppressMovableColumns
        />
      </Box>
    </Box>
  );
};

export default SavedQuantitiesGrid;
